/**
 * GDPR consent banner / modal behaviour for Etrimon.
 * Bundled into the theme's app.js by the theme gulpfile.
 *
 * Cookie format: JSON object `{ analytics, marketing, necessary }` of booleans.
 * On any "save" action we write the cookie and reload the page so that the
 * PHP-side consent state matches what the user just picked.
 */

(function () {
	'use strict';

	var COOKIE_NAME = 'etrimon_gdpr_consent';
	var COOKIE_DAYS = 365;

	function init() {
		var root = document.getElementById('etrimon-gdpr-root');
		if (!root) {
			return;
		}

		var modal = root.querySelector('.etrimon-gdpr-modal');

		root.addEventListener('click', function (event) {
			var target = event.target.closest('[data-etrimon-gdpr-action]');
			if (!target || !root.contains(target)) {
				return;
			}

			var action = target.getAttribute('data-etrimon-gdpr-action');
			switch (action) {
				case 'accept-all':
					save({ analytics: true, marketing: true, necessary: true });
					break;
				case 'reject-all':
					save({ analytics: false, marketing: false, necessary: true });
					break;
				case 'save-settings':
					save(collectSwitches(modal));
					break;
				case 'open-settings':
					openModal(root, modal);
					break;
				case 'close-settings':
					closeModal(root);
					break;
				default:
					break;
			}
		});

		root.addEventListener('click', function (event) {
			var tab = event.target.closest('[data-etrimon-gdpr-tab]');
			if (!tab || !root.contains(tab)) {
				return;
			}
			activateTab(modal, tab.getAttribute('data-etrimon-gdpr-tab'));
		});

		if (modal) {
			modal.addEventListener('click', function (event) {
				if (event.target === modal) {
					closeModal(root);
				}
			});
		}

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && root.classList.contains('is-modal-open')) {
				closeModal(root);
			}
		});
	}

	function openModal(root, modal) {
		if (!modal) {
			return;
		}
		modal.hidden = false;
		root.classList.add('is-modal-open');
		document.body.classList.add('etrimon-gdpr-no-scroll');
	}

	function closeModal(root) {
		root.classList.remove('is-modal-open');
		document.body.classList.remove('etrimon-gdpr-no-scroll');
		var modal = root.querySelector('.etrimon-gdpr-modal');
		if (modal) {
			modal.hidden = true;
		}
	}

	function activateTab(modal, id) {
		if (!modal || !id) {
			return;
		}

		var menuItems = modal.querySelectorAll('[data-etrimon-gdpr-tab]');
		for (var i = 0; i < menuItems.length; i++) {
			menuItems[i].classList.toggle('is-active', menuItems[i].getAttribute('data-etrimon-gdpr-tab') === id);
		}

		var panes = modal.querySelectorAll('[data-etrimon-gdpr-pane]');
		for (var j = 0; j < panes.length; j++) {
			panes[j].classList.toggle('is-active', panes[j].getAttribute('data-etrimon-gdpr-pane') === id);
		}
	}

	function collectSwitches(modal) {
		var state = { analytics: false, marketing: false, necessary: true };
		if (!modal) {
			return state;
		}

		var inputs = modal.querySelectorAll('[data-etrimon-gdpr-consent]');
		for (var i = 0; i < inputs.length; i++) {
			var key = inputs[i].getAttribute('data-etrimon-gdpr-consent');
			state[key] = inputs[i].disabled ? true : !!inputs[i].checked;
		}
		return state;
	}

	function save(state) {
		writeCookie(COOKIE_NAME, JSON.stringify(state), COOKIE_DAYS);
		window.location.reload();
	}

	function writeCookie(name, value, days) {
		var expires = new Date();
		expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
		document.cookie = name + '=' + encodeURIComponent(value) +
			';expires=' + expires.toUTCString() +
			';path=/;SameSite=Lax';
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
